import { useNavigate, useParams } from 'react-router';
import { useSuspenseTOTPAuthenticatorQuery } from '#api/totp-authenticators.queries.ts';
import { Modal, ModalHeader } from '#components/patterns/modal/index.ts';
import { page, Titled } from '#util/title.ts';
import { EditTOTPForm } from './form/EditTOTPForm.tsx';

/**
 * {@link EditTOTPModal} shows a form for editing an existing lighthouse.
 */
export function EditTOTPModal() {
  const params = useParams() as { totpId: string };
  const totpId = params.totpId;
  const totp = useSuspenseTOTPAuthenticatorQuery(totpId).data.data;
  const navigate = useNavigate();

  function returnToUserSettings() {
    void navigate('..', { replace: true });
  }

  const formValues = {
    name: totp.name,
  };

  return (
    <Modal isOpen={true} onClose={returnToUserSettings}>
      <Titled title={() => page('Edit authenticator')}>
        <ModalHeader>{`Edit ${totp.name || 'authenticator'}`}</ModalHeader>
        <EditTOTPForm
          onSuccess={returnToUserSettings}
          onCancel={returnToUserSettings}
          defaultValues={formValues}
          totpID={totp.id}
        />
      </Titled>
    </Modal>
  );
}
